import React from "react";

const HRDVApart = ({ title, description, methods }) => {
  return (
    <section className="hrdv-apart-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          <p>{description}</p>
        </div>

        <div className="row g-4">
          {methods.map((method, i) => (
            <div
              key={i}
              className="col-md-4"
              data-aos="fade-up"
              data-aos-delay={`${i * 100}`}
              data-aos-once="true"
            >
              <div className="hrdv-apart-card">
                <p className="hrdv-apart-label">{method.label}</p>
                <p className="hrdv-apart-desc">{method.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HRDVApart;
